import React, { useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { useContext } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import { SearchFiltersActionTypes } from '../../../../reducers/search-filters/actions';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import Button from '../../../../new-components/ui/Button';
// import { setQuickFilter } from '../../../../redux/slices/sahelSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { getNowDate } from '../../../../helpers/search-options/common';
import {
  setDrawerOpen,
  setQuickFilter,
  setSearchDrawerOpen
} from '../../../../redux/slices/mapSlice';
import useOnClickOutside from '../../../../hooks/ClickOutside';
import { ResultsType } from '../../types';

const OnboardingPresentation = () => {
  const containerRef = useRef(null);
  const resultsType = useSelector((state: any) => state.map.resultsType);
  useOnClickOutside(containerRef, containerRef, () => {
    dispatch(setQuickFilter(null));
  });
  const { searchFiltersDispatch } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const dispatch = useDispatch();
  const { locale } = useRouter();
  const { t } = useTranslation(['common', 'map']);
  const applyNawyNowFilter = () => {
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
      payload: {
        name: SearchFiltersTypes.NAWY_NOW,
        value: true
      }
    });
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
      payload: {
        name: SearchFiltersTypes.DELIVERY_DATE,
        value: getNowDate()
      }
    });
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
      payload: {
        name: SearchFiltersTypes.DELIVERY_YEARS,
        value: []
      }
    });
    dispatch(setQuickFilter(null));
    if (resultsType === ResultsType.COMPOUNDS) {
      dispatch(setDrawerOpen(true));
    }
    dispatch(setSearchDrawerOpen(true));
  };
  return (
    <Container ref={containerRef}>
      <div className="onboarding-header">
        <h2>Nawy Now</h2>
      </div>

      {locale === 'en' ? (
        <span className="onboarding-description">
          {t('find', { ns: 'map' })}
          <span className="highlight-description">
            {' '}
            {t('move_now_pay_later', { ns: 'map' })}{' '}
          </span>
          {t('properties', { ns: 'map' })}
        </span>
      ) : (
        <span className="onboarding-description">
          {t('onboard_description', { ns: 'map' })}{' '}
          <span className="highlight-description">
            {t('onboard_highlight', { ns: 'map' })}
          </span>
        </span>
      )}
      <div className="onboarding-info">
        <span>{t('onboarding_info_first', { ns: 'map' })}</span>
        <span>{t('onboarding_info_second', { ns: 'map' })}</span>
      </div>
      <Button
        text={t('apply')}
        backgroundColor="#1E4164"
        color="#fff"
        border="1px solid #006694"
        fontSize="14px"
        onClick={applyNawyNowFilter}
        btnClass="action-btn"
        containerClass="btn-container"
      />
    </Container>
  );
};

const Container = styled.div<any>`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  background-color: #fff;
  .onboarding-header {
    display: flex;
    justify-content: center;
    align-items: center;

    h2 {
      color: #2c3138;
      text-align: center;
      font-family: materialSemiBold;
      font-size: 22px;
      margin-left: 6px;
    }
  }

  .onboarding-description {
    color: #475467;
    text-align: center;
    font-family: materialMedium;
    font-size: 15px;

    .highlight-description {
      color: #ff5e00;
    }
  }

  .onboarding-info {
    display: flex;
    gap: 8px;
    span {
      display: flex;
      padding: 16px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex: 1 0 0;
      border-radius: 8px;
      background: #f9fafb;
      color: #475467;
      text-align: center;
      font-family: materialRegular;
      font-size: 14px;
    }
  }
  button {
    width: 100%;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    margin-top: 0px;
    gap: 16px;
    .onboarding-header {
      h2 {
        font-size: 18px;
      }
    }
    .onboarding-description {
      font-size: 14px;
    }

    .onboarding-info {
      span {
        background: #f9fafb;
      }
    }

    .btn-container {
      position: sticky;
      bottom: 0;
      width: 100%;
    }
    button {
      margin-top: 8px;
      height: 45px;
    }
  }
`;

export default OnboardingPresentation;
